import { ChakraProvider } from '@chakra-ui/react';
import { createRoot } from 'react-dom/client';
import generatePDF, { Margin } from 'react-to-pdf';
import themeV1 from 'themes/v1/theme';
import themeV2 from 'themes/v2/theme';
import InvoicePreview from '../components/InvoicePreview';
import { buildInvoicePdfFilename } from './invoicePdfFilename';

const appTheme = process.env.REACT_APP_IS_NEW_DESIGN === 'true' ? themeV2 : themeV1;

export async function downloadInvoicePdf(invoice) {
  if (!invoice) {
    throw new Error('Invoice is required');
  }

  const mountNode = document.createElement('div');
  mountNode.style.position = 'fixed';
  mountNode.style.left = '-10000px';
  mountNode.style.top = '0';
  mountNode.style.width = '794px';
  mountNode.style.background = 'white';
  document.body.appendChild(mountNode);

  let root;
  try {
    root = createRoot(mountNode);
    root.render(
      <ChakraProvider theme={appTheme}>
        <div data-invoice-pdf-root="true">
          <InvoicePreview
            pdfMode
            invoiceNumber={invoice.invoiceNumber}
            invoiceDate={invoice.invoiceDate}
            dueDate={invoice.dueDate}
            billingDetails={invoice.billingDetails}
            lines={invoice.lines || []}
            setOffEnabled={invoice.setOffEnabled}
            requestReceivedDate={invoice.requestReceivedDate}
            fundingMonthKey={invoice.fundingMonthKey}
            growthInvestment={invoice.growthInvestment ?? invoice.purchaseAmount}
            growthInvestments={invoice.growthInvestments}
            setOffCreatedDate={invoice.setOffCreatedDate}
            signature={invoice.signature}
          />
        </div>
      </ChakraProvider>
    );

    await new Promise((resolve) => requestAnimationFrame(resolve));
    await new Promise((resolve) => requestAnimationFrame(resolve));

    const getPdfTargetElement = () =>
      mountNode.querySelector('[data-invoice-pdf-root]') || mountNode.firstElementChild;

    await generatePDF(getPdfTargetElement, {
      method: 'save',
      filename: buildInvoicePdfFilename(invoice.invoiceNumber),
      page: { margin: Margin.SMALL },
    });
  } finally {
    if (root) {
      root.unmount();
    }
    if (mountNode.parentNode) {
      mountNode.parentNode.removeChild(mountNode);
    }
  }
}
